var DATA_URI_PATTERN = /^data:(\S*?)?(;charset=[^;]+)?(;[^,]+?)?,(.+)/;

function matchDataUri(uri) {
  return DATA_URI_PATTERN.exec(uri);
}

module.exports = matchDataUri;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/reader/match-data-uri.js
// module id = 737
// module chunks = 0 1